import React, {Component} from "react";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";
import {FormattedMessage} from "react-intl";


class UserAddressList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userAddresses: [],
            country: ""
        };

        this.getUserAddresses = this.getUserAddresses.bind(this);
    }

    componentDidMount() {
        this.getUserAddresses();
    }

    getUserAddresses = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        // console.log(this.props.userId);
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/addresses', axiosConfig)
            .then((res) => {
                // console.log('addresses------******------------>', res.data);


                if (res.data[0].country == "jp") {

                    this.setState({
                        country: "日本",
                    })
                }
                this.setState({
                    userAddresses: res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    render() {
        let no = 1;
        return (

            <div className=" admin-user-address-list-scroll customer-address-list-resp">

                <div className="admin-table-row-content">
                    <div>

                        <div className="row info-table-header ">
                            <div className="col-md-1 custom-col-1">
                                <label>#</label>
                            </div>
                            <div className="col-md-2 custom-col-2 no-padding">
                                <label>
                                    <FormattedMessage id="app.admin.customer.info.name"
                                                      defaultMessage=" Name"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-2 custom-col-2">
                                <label>
                                    <FormattedMessage id="app.admin.customer.info.phone"
                                                      defaultMessage="Phone"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-3 custom-col-3">
                                <label>
                                    <FormattedMessage id="app.user-profile.user-profile-info.address"
                                                      defaultMessage="Address"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-1 custom-col-1 no-padding">
                                <label>
                                    {/*<FormattedMessage id="app.admin.customer.info.province"*/}
                                    {/*defaultMessage="Province"*/}
                                    {/*description=""/>*/}
                                </label>
                            </div>

                            <div className="col-md-1 custom-col-1">
                                <label>
                                    <FormattedMessage id="app.user-profile.user-profile-info.country"
                                                      defaultMessage="Country"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-2 custom-col-2 no-padding">
                                <label>
                                    <FormattedMessage id="app.admin.customer.info.company"
                                                      defaultMessage="Company"
                                                      description=""/>
                                </label>

                            </div>

                        </div>
                    </div>
                    {this.state.userAddresses.length !== 0 ?
                        this.state.userAddresses.map((item) => {
                            return (

                                <div key={item.id}>
                                    <hr/>
                                    <div className="row">
                                        <div className="col-md-1 custom-col-1">
                                            {no++}
                                        </div>
                                        <div className="col-md-2 custom-col-2 no-padding">
                                            {item.lastName}&nbsp;{item.firstName}
                                        </div>
                                        <div className="col-md-2  custom-col-2">
                                            {item.cellOrMobileNumber}
                                        </div>
                                        <div className="col-md-3 custom-col-3">
                                            <div>{item.postalCode}</div>
                                            <div>{item.province}</div>
                                            <div>{item.city}</div>
                                            <div>{item.streetAddress},{item.addressLine2} </div>

                                            {/*<p>{item.postalCode}room number</p>*/}

                                            {/*{item.addressLine2},{item.streetAddress},{item.city}*/}
                                            <br/>
                                        </div>
                                        <div className="col-md-1 custom-col-1">
                                        </div>
                                        <div className="col-md-1 custom-col-1">
                                            {item.country}
                                        </div>
                                        <div className="col-md-2 custom-col-2 no-padding">
                                            {item.companyName}
                                        </div>

                                    </div>
                                </div>
                            );
                        }) :
                        <div className="text-center">
                            <br/>
                            <FormattedMessage id="app.no-records-found"
                                              defaultMessage="No records found" description=""/>
                        </div>}

                </div>
            </div>
        );


    }

}

export default UserAddressList;



// WEBPACK FOOTER //
// ./src/components/Admin/Customer/UserAddressList.js